import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MostPopularCourses from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import {
  MostPopularCoursesNavbar,
  BackHeader,
  SideMenu,
} from "./../../components";
import { useNavigate, useLocation } from "react-router-dom";
let OurLatestUpdate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let CardData = [
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
  ];
  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Our latest update</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12} key={i}>
                      <Button
                        className="card-button-main"
                        onClick={() => {
                          navigate("/our-latest-update/details", {
                            state: { type: location.state.type },
                          });
                        }}
                      >
                        <img src={MostPopularCourses} className="card-image" />
                        <div className="card-latest-update-desctiption-main">
                          <p className="card-latest-update-desctiption">
                            Aliquam nulla nulla, eleifend sit amet bibendum sit
                            amet, vulputate eget nunc
                          </p>
                          <p className="card-upcomming-event-date">
                            14 march 2022,
                          </p>
                        </div>
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </div>
      ) : (
        <SideMenu>
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Our latest update</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12} key={i}>
                      <Button
                        className="card-button-main"
                        onClick={() => {
                          navigate("/our-latest-update/details", {
                            state: { type: location.state.type },
                          });
                        }}
                      >
                        <img src={MostPopularCourses} className="card-image" />
                        <div className="card-latest-update-desctiption-main">
                          <p className="card-latest-update-desctiption">
                            Aliquam nulla nulla, eleifend sit amet bibendum sit
                            amet, vulputate eget nunc
                          </p>
                          <p className="card-upcomming-event-date">
                            14 march 2022,
                          </p>
                        </div>
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </SideMenu>
      )}
    </div>
  );
};
export default OurLatestUpdate;
